// extracted by mini-css-extract-plugin
export var chevron = "_kc-2";
export var dropdownItems = "_kc-0";
export var item = "_kc-1";